module.exports = __webpack_public_path__ + "img/mobile/SmartButton/btn-bet-portrait-up@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/SmartButton/btn-bet-portrait-up@1x.png
// module id = 226
// module chunks = 0